import { SVGProps, memo } from "react";

function SmilingEmoji(props: SVGProps<SVGSVGElement>) {
    return (
        <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" {...props}>
            <circle cx={8} cy={8} r={5.5} stroke={props.color || "#27AF8F"} />
            <path
                d="M10.4 9H5.6c-.247 0-.39.283-.232.473C5.928 10.155 6.806 11 8 11c1.194 0 2.072-.845 2.632-1.527.157-.19.015-.473-.232-.473z"
                fill={props.color || "#27AF8F"}
            />
            <circle cx={5.75} cy={6.75} r={0.75} fill={props.color || "#27AF8F"} />
            <circle cx={10.251} cy={6.75} r={0.75} fill={props.color || "#27AF8F"} />
        </svg>
    );
}

const MemoSmilingEmoji = memo(SmilingEmoji);
export default MemoSmilingEmoji;
